module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av227-4f3e5620ef6cc0d523a53a687be7821b.jpg";